module.exports = "/images/external-link.svg";